export default __webpack_public_path__ + "e8468af440f3398fb1519862baa2b49a.svg";